import React from 'react'

import DeviceError from '../errors/DeviceError'

class DeviceErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.log('Handling Device Error > Rendering DeviceError Component')
  }

  render() {
    if (this.state.hasError) {
      return <DeviceError />
    }

    return this.props.children
  }
}

export default DeviceErrorBoundary
